import * as actions from '../../actions/task/taskActions'

export const initialState = {
    loading: false,
    hasErrors: false,
    taskDropdownLists: []
}

export default function taskDropdownListsReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_DROPDOWN_LISTS:
            return { ...state, loading: true }
        case actions.GET_DROPDOWN_LISTS_SUCCESS:
            return { taskDropdownLists: [...state.taskDropdownLists, action.payload], loading: false, hasErrors: false }
        case actions.GET_DROPDOWN_LISTS_FAILURE:
            return { ...state, loading: false, hasErrors: true }
        default:
            return state
    }
}